<template>

<el-dialog
        v-model="editCityForm"
        title="修改城市"
        width="500"
        destroy-on-close
        center>
        <span>
        <div class="mb-3 row">
            <label for="" class="col-sm-2 col-form-label">城市</label>
            <div class="col-sm-9">
              <CityComponent @dataCity='getCity' @blur="checkCity"/>
            </div>
            <div class="col-sm-1">
            <span style="color: red">*</span>
            </div>
        </div>
        </span>
        <template #footer>
        <div class="dialog-footer">
            <el-button @click="editCityForm = false">取消</el-button>
            <el-button type="submit" @click="editCityOk();"> 提交 </el-button>
        </div>
        </template>
    </el-dialog>



  <div class="common-layout">
    <el-container>
      <el-container>
        <el-aside width="300px" style="height: 100%;" class="aside">
      <!-- 个人信息展示 -->
      <el-row>
        <el-col>
          <el-card :body-style="{ padding: '0px' }">
            <div v-if="showText"  class="flip-animation">
              <div style="padding: 14px;" @mouseleave="toggleShowText" v-if="$store.state.user.is_login">
                <span style="font-size:x-large; font-weight: bold;">地区:{{ $store.state.weather.province }} {{ $store.state.weather.city }}</span> <br>
                <span style="font-size:larger;">天气:{{ $store.state.weather.weather }} </span> <br>
                <span style="font-size:larger; "> 温度:{{ $store.state.weather.temperature }}</span> <br>
                <span style="font-size:larger; ">风向:{{ $store.state.weather.winddirection }} </span> <br>
                <span style="font-size:larger; "> 风力:{{ $store.state.weather.windpower }}</span><br>
                <span style="font-size:larger; ">空气湿度:{{ $store.state.weather.humidity }}</span>
                <div class="bottom">
                  <hr style="margin-top: 30px">
                  <el-button type="info" @click="editCityForm = true" plain>更换城市</el-button>
                  <time class="time" style="color: rgb(146, 144, 144); font-size: xx-small;">更新时间: {{$store.state.weather.reporttime}}</time>
                </div>
              </div>
              <div style="padding: 1px;" @mouseleave="toggleShowText" v-else-if="!$store.state.user.is_login">
                <img class="lundata" :src="$store.state.options.seasoncard" />
              </div>
            </div>
            <div style="padding: 1px;" v-else @mouseenter="toggleShowText" class="flip-animation">
              <img class="lundata" :src="$store.state.options.seasoncard" />
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-aside>
        <el-main class="main">
          <div class="block text-center">
            <el-carousel class="lun">
              <el-carousel-item>
                <h3 class="small justify-center" text="2xl">
                    <img class="lunimg" :src="$store.state.options.lun1" alt="">
                </h3>
              </el-carousel-item>
              <el-carousel-item>
                <h3 class="small justify-center" text="2xl">
                    <img class="lunimg" :src="$store.state.options.lun2" alt="">
                </h3>
              </el-carousel-item>
              <el-carousel-item>
                <h3 class="small justify-center" text="2xl">
                    <img class="lunimg" :src="$store.state.options.lun3" alt="">
                </h3>
              </el-carousel-item>
            </el-carousel>
          </div>
        </el-main>
      </el-container>

      
    </el-container>
  </div>
</template>
  
<script setup>
import $ from 'jquery';
import { useStore } from 'vuex';
import { ElMessage } from "element-plus";
import CityComponent from '@/components/data/CityComponent.vue'

const store = useStore();
const city = ref("");
const editCityForm = ref(false);


import {ref} from 'vue'
let showText = ref(false);
const toggleShowText = () => {
  showText.value = !showText.value;  
}

let token = localStorage.getItem("token");

if (token != '') {
  $.ajax({
    url: "http://124.222.105.205:5000/api/san/weather",
    type: "get",
    headers: {
        Authorization: "Bearer " + token,
    },
    success(resp) {
        if (resp.code === "200") {
            store.commit("updateWeather", resp.data.lives[0]);
            console.log(resp);
        } else {
          console.log(resp);
        }
    }
});
}

const editCityOk = () => {
  if(city.value == '') {
    ElMessage({
        type: "error",
        message: "请选择城市",
    });
    return false;
  }
  $.ajax({
        url: "http://124.222.105.205:5000/api/user/updateUserCity",
        data: {
            city: city.value,
            userId: store.state.user.id,
        },
        type: "post",
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
            ElMessage({
                type: "success",
                message: resp.msg,
            });
            location.reload();
            } else {
            ElMessage({
                type: "error",
                message: resp.msg,
            });
            }
        },
        error() {
            ElMessage({
            type: "error",
            message: "服务器异常!请稍后再试!",
            });
        }
    })

}

const getCity = (adCode) => {
  city.value = adCode;
  console.log(adCode);
}

</script>

  <style scoped>
.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
  text-align: center;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
 .lundata{
    width: 100%;
    height: 300px;

}

.lunimg{
    width: 100%;
    height: 350px;

}

.lunimg:hover{
     width: 100%;
    height: 360px;
    transition: 500ms;
    cursor: pointer;
}
.lun, .aside, .header{
    border: 3px solid rgba(144, 143, 143, 0.411);
    border-radius: 20px;
}

.flip-animation {
  height: 300px;
  animation: flip 0.5s;
  transform-style: preserve-3d;
}
@keyframes flip {
  from {
    transform: perspective(400px) rotateY(0) scaleX(1);
  }
  to {
    transform: perspective(400px) rotateY(180deg) scaleX(-1);
  }
}


.main{
    padding-top: 0px;
    padding-bottom: 0px;
  }
</style>
  